import $ from "jquery";

const defaultNavHeight = 462;
const navBreakpoint = 980;

function activateItem($this, $item, $flyout) {
  const activeClass = "active";
  const target = $this.data("target");
  const $target = $(target);
  const isActive = $this.hasClass(activeClass);
  const isBack = $this.data("isBack");
  const $flyoutTab = $(".js-nav-flyout-tab.active");
  const $flyoutGroup = $(".js-flyout-group.active");

  // Deactivate current item
  $item.removeClass(activeClass);
  $flyout.removeClass(activeClass);

  // Deactivate active flyouts when user clicks on a top level tab / other flyout tab
  $flyoutTab.removeClass(activeClass);
  $flyoutGroup.removeClass(activeClass);

  $item.attr("aria-expanded", false);
  $flyoutTab.attr("aria-expanded", false);

  if (isBack) {
    $target.removeClass(activeClass);
    resetLowerNav();

    // Accessibility
    // Reset all links in the nav - primary level ones are tabbable, secondary & tertiary - not
    $(".js-nav a, .js-nav button").attr("tabIndex", 0);
    $(".js-flyout a, .js-flyout button").attr("tabIndex", -1);
  } else if (!isActive) {
    // Activate this item and its menu
    $this.addClass(activeClass);
    $target.addClass(activeClass);

    // Accessibility
    $this.attr("aria-expanded", true);
    if ($target.hasClass("js-flyout-group")) {
      // Deactivate all other tertiary nav descendant links, apart from this active one's
      $(".js-flyout-group a, .js-flyout-group button").attr("tabIndex", -1);
      $target.find("a, button").attr("tabIndex", 0); // Activate children (tertiary nav items)
    } else if ($target.hasClass("js-flyout")) {
      $target.find("a, button").attr("tabIndex", 0); // Activate children (secondary nav items)
      $(".js-flyout-group a, .js-flyout-group button").attr("tabIndex", -1); // Deactivate all tertiary nav items
    }
  } else {
    // Accessibility: deactivate all tertiary nav items
    if (!$target.hasClass("js-flyout")) {
      $(".js-flyout-group a, .js-flyout-group button").attr("tabIndex", -1);
    }
  }
}

function heightMe($item) {
  const activeClass = "active";
  const target = $item.data("target");
  const targetH = $(target).outerHeight();
  const isItemActive = $item.hasClass(activeClass);
  const minH = isItemActive && targetH > defaultNavHeight ? targetH : defaultNavHeight;
  $item.parents(".nav__flyout-inner").css("height", minH);

  if (isItemActive) {
    $(".nav__flyout-group-block").removeClass(activeClass);
    $item.parents(".nav__flyout-group-block").addClass(activeClass);
  } else {
    $(".nav__flyout-group-block").removeClass(activeClass);
  }
}

function resetLowerNav() {
  const activeClass = "active";
  const $flyoutTab = $(".js-nav-flyout-tab");
  // Lower level
  $flyoutTab.removeClass(activeClass);
  $(".js-flyout-group").removeClass(activeClass);
  // Other resets
  $(".nav__flyout-inner").css("height", defaultNavHeight);
  $(".nav__flyout-group-block").removeClass(activeClass);
  // Accessibility
  $flyoutTab.attr("aria-expanded", false);
}

function resetNav(resetBody = false) {
  const activeClass = "active";
  // All levels
  $(".nav" + " ." + activeClass).removeClass(activeClass);
  $(".nav__flyout-inner").css("height", defaultNavHeight);
  if (resetBody) {
    $(".nav-open").removeClass("nav-open");
    $(".nav-overlay").removeClass("shown");
    $(".js-nav-tab").attr("aria-expanded", false);
    $(".js-nav-flyout-tab").attr("aria-expanded", false);
  }
}

function pushToDataLayer(eventAction: string, eventLabel: string, topNav: string) {
  window.dataLayer.push({
    event: "navigation",
    eventCategory: "navigation",
    eventAction: eventAction,
    eventLabel: eventLabel,
    top_navigation: topNav,
  });
}

function init(): void {
  // Nav toggle
  const $navToggle = $(".js-nav-toggle");

  // Higher level
  const $navTab = $(".js-nav-tab");
  const $navFlyout = $(".js-flyout");

  // Lower level
  const $navFlyoutTab = $(".js-nav-flyout-tab");
  const $navFlyoutGroup = $(".js-flyout-group");

  // Accessibility: disable tabbing at the start (not in HTML as it relies on JS & would stop user from using the nav with keyboard)
  if ($navFlyout.length) {
    $(".js-flyout button, .js-flyout a").attr("tabIndex", -1);
  }

  const $links = $(".nav__list-item-link");
  $links.click((e) => {
    if (window.dataLayer) {
      pushToDataLayer("top_navigation", e.target.textContent, e.target.textContent);
    }
  });

  const $subLinks = $(".nav__list-item .nav__flyout-description--with-btn > a");
  $subLinks.click((e) => {
    if (window.dataLayer) {
      pushToDataLayer("_navigation", e.target.textContent, e.target.textContent);
    }
  });

  $navTab.click(function () {
    const $this = $(this);
    activateItem($this, $navTab, $navFlyout);
    heightMe($this);
    if ($this.hasClass("active")) {
      $(".nav-overlay").addClass("shown");
    } else {
      $(".nav-overlay").removeClass("shown");
    }

    // On mobile menu'd devices, scroll to top when this changes, as they may have selected item 12 from a long menu, which only has 1 or 2 sub items, which would be invisible based on current scroll position
    if (window.innerWidth < navBreakpoint) {
      $(".js-header").animate(
        {
          scrollTop: 0,
        },
        500
      );
    }
  });
  $navFlyoutTab.click(function () {
    const $this = $(this);
    activateItem($this, $navFlyoutTab, $navFlyoutGroup);
    heightMe($this);
  });

  // Initial setup
  resetNav(true);

  // Re-run setup on orientation change
  $(window).on("orientationchange", () => {
    resetNav(true);
  });

  // Re-run setup on resize (with additional check because iOS is firing unnecessary resize events when scrolling)
  // https://stackoverflow.com/questions/8898412/iphone-ipad-triggering-unexpected-resize-events
  // Store the window width
  const $window = $(window);
  let windowWidth = $window.width();
  $window.on("resize", () => {
    // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
    if ($window.width() != windowWidth) {
      // Update the window width for next time
      windowWidth = $window.width();
      resetNav(true);
    }
  });

  // Reset nav upon closing
  $navToggle.click(function () {
    const $this = $(this);
    resetNav(); // Don't reset the class on the body as the js-toggle-class already handles that
    $navToggle.blur(); // Accessibility: remove outline on toggle (if done with CSS, it'll never show on focus; we just remove it on click)
    // Accessibility
    if ($this.hasClass("nav-open")) {
      $this.attr("aria-expanded", false);
    } else {
      $this.attr("aria-expanded", true);
    }
  });

  $(".nav-overlay").click(function () {
    $(".nav-open").removeClass("nav-open"); // On page container
    resetNav(true);
    $navToggle.blur(); // Accessibility: remove outline on toggle (if done with CSS, it'll never show on focus; we just remove it on click)
  });

  // Initial accessibility:
  $navToggle.attr("aria-haspopup", "menu");
  $navTab.attr("aria-haspopup", "menu");
  $navFlyoutTab.attr("aria-haspopup", "menu");
}

export default { init };
